import React from "react";
import styled from "styled-components";
import { primaryColor, tuftsBlue } from "../../../constants/colors";
import { format4DigitTimeToAmOrPM } from "../../../utils/utils";

const AppointmentTimeInfo = ({ date, time, type }) => {
  const getFormattedDate = () => {
    const givenDate = new Date(date);
    const formattedDate = givenDate.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    return formattedDate;
  };

  return (
    <Wrapper>
      <div className="row px-4 py-3">
        <div className="d-flex justify-content-between rounded gap-3">
          <div className="d-flex flex-column ">
            <span className="txt-gray">Date</span>
            <strong className="fs-normal fw-medium">{getFormattedDate()}</strong>
          </div>
          <div className="d-flex flex-column ">
            <span className="txt-gray">Time</span>
            <strong className="fs-normal fw-medium">{format4DigitTimeToAmOrPM(time)}</strong>
          </div>
          <div className="d-flex flex-column ">
            <span className="txt-gray">Type</span>
            <strong className=" fs-normal fw-medium">{type}</strong>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default AppointmentTimeInfo;

const Wrapper = styled.div`
  background-color: #fafafa;
  .txt-gray {
    color: #b1b1b1;
    font-size: 0.9rem;
  }
  .txt-primary {
    color: ${primaryColor};
  }
  strong {
    color: ${tuftsBlue};
  }
`;
